"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
var Checkbox_module_scss_1 = __importDefault(require("./Checkbox.module.scss"));
var CheckMarker_1 = require("../checkMarker/CheckMarker");
var Checkbox = function (props) {
    var id = props.id, textContent = props.textContent, register = props.register, isError = props.isError;
    return (react_1.default.createElement("label", { className: Checkbox_module_scss_1.default.checkbox_label, htmlFor: id },
        react_1.default.createElement("input", __assign({}, register, { className: Checkbox_module_scss_1.default.checkbox_label__checkbox, type: "checkbox", id: id })),
        react_1.default.createElement("div", { className: "".concat(Checkbox_module_scss_1.default.checkbox_label__checkbox_custom, " ").concat(isError && isError !== 'no error' ? 'field_error' : '') },
            react_1.default.createElement(CheckMarker_1.CheckMarker, null)),
        react_1.default.createElement("p", { className: Checkbox_module_scss_1.default.checkbox_label__text }, textContent)));
};
exports.Checkbox = Checkbox;
